const contentObjectToString = content => {
  let articleContent = content.content + ' ' + content.htmlTitle + ' ' + content.htmlMetadescription + ' ' + content.title + ' '
  if (content.faq) {
    articleContent + content.faq.title + ' '
    if (content.faq.questions) {
      content.faq.questions.forEach(question => {
        articleContent + `${question.question} ${question.answer} `
      })
    }
  }
  if (content.howTo) {
    articleContent + content.howTo.headline + ' '
    articleContent + content.howTo.description + ' '
    articleContent + content.howTo.time + ' '
    articleContent + content.howTo.tool + ' '
    articleContent + content.howTo.supply + ' '
    if (content.howTo.steps) {
      content.howTo.steps.forEach(step => {
        articleContent + `${step.headline} ${step.name} ${step.description} `
      })
    }
  }
  if (content.site.id === 'casinobernie' && content.prosConsShortcode) {
    articleContent + content.prosConsShortcode.headline + ' ' + content.prosConsShortcode.description + ' '
    if (content.prosConsShortcode.pros) {
      content.prosConsShortcode.pros.forEach(pro => {
        articleContent = ` ${pro.item} `
      })
    }
    if (content.prosConsShortcode.cons) {
      content.prosConsShortcode.cons.forEach(con => {
        articleContent = ` ${con.item} `
      })
    }
  }
  let reviewContent = content.title + ' ' + content.summary + ' ' + content.bonusReview + ' ' + content.gameSelectionReview + ' '
  if (content.cons) {
    reviewContent + content.cons[0] + ' ' + content.cons[1] + ' '
  }
  if (content.pros) {
    reviewContent + content.pros[0] + ' ' + content.pros[1] + ' ' + content.pros[2]
  }
  return articleContent + reviewContent
}

module.exports = {
  contentObjectToString,
}
